import { CareerPathMeaning, CareerPathEnjoyment } from '../models/models';

export const TRADE_SPECIFIC_QUESTION_KEYS = {
  ACTIVITIES_YOU_ENJOY: 'activities_you_enjoy',
  ACTIVITIES_YOU_DONT_LIKE: 'activities_you_dont_like',
  EDUCATIONAL_CHOICES: 'educational_choices', // high school choice
  EDUCATIONAL_CHOICES_COLLEGE: 'educational_choices_college',
} as const;

export const TRADE_SPECIFIC_CELL_KEYS = {
  cell_D53: 'activities_you_enjoy_working_with_your_hands',
  cell_D56: 'activities_you_enjoy_serving_or_caring',
  cell_D61: 'activities_you_enjoy_following_a_playbook',
  cell_D65: 'activities_you_dont_enjoy_working_with_your_hands',
  cell_D68: 'activities_you_dont_enjoy_serving_or_caring',
  cell_D73: 'activities_you_dont_enjoy_following_a_playbook',
  cell_D77: 'educational_choices_very_selective_college',
  cell_D78: 'educational_choices_trade_school_or_apprenticeship_program',
  cell_D78a: 'educational_choices_college_apprenticeship_program',
} as const;

export const ENTREPRENEURSHIP_SPECIFIC_QUESTION_KEYS = {
  BUILDING_WEALTH: 'building_wealth',
  ACTIVITIES_YOU_DONT_LIKE: "activities_you_don't_like",
  ACTIVITIES_YOU_ENJOY: 'activities_you_enjoy',
} as const;

export const ENTREPRENEURSHIP_SPECIFIC_CELL_KEYS = {
  cell_D28: 'building_wealth_very_important',
  cell_D67: 'activities_you_dont_enjoy_promoting_or_selling',
  cell_D72: 'activities_you_dont_enjoy_making_decisions',
  cell_D74: 'activities_you_dont_enjoy_leading_people',
  cell_D55: 'activities_you_enjoy_promoting_or_selling',
  cell_D60: 'activities_you_enjoy_making_decisions',
  cell_D62: 'activities_you_enjoy_leading_people',
} as const;

export const USER_SUMS_QUESTION_KEYS = {
  SOURCES_OF_MEANING_QUESTION: 'sources_of_meaning',
  ACTIVITIES_YOU_ENJOY_QUESTION: 'activities_you_enjoy',
  ACTIVITIES_YOU_DONT_LIKE_QUESTION: 'activities_you_dont_like',
} as const;

/*
 *
 * these are response option ids that correspond to the meaning question. Ex: Option ID 49 is "Relationships" in the Sources of Meaning question
 *
 */
export const OPTION_ID_TO_MEANING_KEY_MAP: Record<string, keyof CareerPathMeaning> = {
  sources_of_meaning_relationships: 'relationships_value',
  sources_of_meaning_legacy: 'legacy_value',
  sources_of_meaning_personal_growth: 'personal_growth_value',
  sources_of_meaning_social_impact: 'social_impact_value',
  sources_of_meaning_innovation: 'innovation_value',
  sources_of_meaning_connection_to_nature: 'connection_to_nature_value',
  sources_of_meaning_creativity: 'creativity_value',
  sources_of_meaning_benefitting_others: 'benefiting_others_value',
  sources_of_meaning_honoring_spiritual_beliefs: 'honoring_spiritual_beliefs_value',
};

export const OPTION_ID_TO_ENJOYMENT_KEY_MAP: Record<string, keyof CareerPathEnjoyment> = {
  activities_you_enjoy_working_with_your_hands: 'working_with_hands_value',
  activities_you_enjoy_creating: 'creating_value',
  activities_you_enjoy_promoting_or_selling: 'promoting_or_selling_value',
  activities_you_enjoy_serving_or_caring: 'serving_or_caring_value',
  activities_you_enjoy_coaching_teaching_advising: 'coaching_teaching_advising_value',
  activities_you_enjoy_analyzing_and_solving_problems: 'analyzing_and_solving_problems_value',
  activities_you_enjoy_collaborating: 'collaborating_value',
  activities_you_enjoy_making_decisions: 'making_decisions_value',
  activities_you_enjoy_following_a_playbook: 'following_a_playbook_value',
  activities_you_enjoy_leading_people: 'leading_people_value',
};

export const OPTION_ID_TO_DISLIKE_KEY_MAP: Record<string, keyof CareerPathEnjoyment> = {
  activities_you_dont_like_working_with_your_hands: 'working_with_hands_value',
  activities_you_dont_like_creating: 'creating_value',
  activities_you_dont_like_promoting_or_selling: 'promoting_or_selling_value',
  activities_you_dont_like_serving_or_caring: 'serving_or_caring_value',
  activities_you_dont_like_coaching_teaching_advising: 'coaching_teaching_advising_value',
  activities_you_dont_like_analyzing_and_solving_problems: 'analyzing_and_solving_problems_value',
  activities_you_dont_like_collaborating: 'collaborating_value',
  activities_you_dont_like_making_decisions: 'making_decisions_value',
  activities_you_dont_like_following_a_playbook: 'following_a_playbook_value',
  activities_you_dont_like_leading_people: 'leading_people_value',
};
